export default "__VITE_ASSET__DcQ0Q83B__"